const priceFormatter = Intl.NumberFormat("da-DK", { currency: "DKK" });
const longTimeFormatter = Intl.DateTimeFormat("da-DK", {
  hourCycle: "h23",
  timeStyle: "long",
});
const shortTimeFormatter = Intl.DateTimeFormat("da-DK", {
  hourCycle: "h23",
  timeStyle: "short",
});

function ensureNumber(n: number | undefined | null | bigint) {
  if (!n || isNaN(n as number)) return 0;
  return n;
}

export function formatMoney(money: number | bigint) {
  return priceFormatter.format(ensureNumber(money));
}
export function formatTime(date: Date, style: "long" | "short" = "short") {
  return (
    style === "short"
      ? shortTimeFormatter.format(date)
      : longTimeFormatter.format(date)
  ).replace(".", ":");
}

export function dedent(
  strings: TemplateStringsArray,
  ...values: any[]
): string {
  // 1. Reconstruct the full string from the template literals
  const text = strings.reduce(
    (result, str, i) => result + str + (values[i] || ""),
    ""
  );

  // 2. Split into lines
  const lines = text.split("\n");

  // 3. Remove leading and trailing empty lines
  while (lines.length > 0 && lines[0].trim() === "") {
    lines.shift();
  }
  while (lines.length > 0 && lines[lines.length - 1].trim() === "") {
    lines.pop();
  }

  // 4. Calculate the minimum indentation level (ignoring empty lines)
  const minIndent = lines.reduce((min, line) => {
    if (line.trim().length === 0) return min;
    const indent = line.match(/^\s*/)?.[0].length || 0;
    return Math.min(min, indent);
  }, Infinity);

  // 5. Remove the common indentation and rejoin
  if (minIndent === Infinity) return lines.join("\n");

  return lines
    .map((line) => (line.length >= minIndent ? line.slice(minIndent) : line))
    .join("\n");
}

const daysInDanish = [
  "Søndag",
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
];

export function formatDay(day: number) {
  return daysInDanish[day % daysInDanish.length];
}
